module.exports = __webpack_public_path__ + "img/check-white.4e90a028.svg";